import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';
import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

interface SkeletonProps
  extends ComponentProps<React.HTMLAttributes<HTMLDivElement>> {
  level?: 1 | 2 | 3 | 4 | 5;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const skeletonVariants = variants({
  base: 'w-full animate-pulse bg-level-02',
  variants: {
    level: {
      1: 'bg-level-01',
      2: 'bg-level-02',
      3: 'bg-level-03',
      4: 'bg-level-04',
      5: 'bg-level-05',
    },
    size: {
      sm: 'h-sm rounded-sm',
      md: 'h-md rounded-md',
      lg: 'h-lg rounded-lg',
      xl: 'h-xl rounded-xl',
    },
  },
});

function Skeleton({ level = 2, size = 'md', ...props }: SkeletonProps) {
  const className = getClassNameOverride(props, 'Skeleton');

  return (
    <div
      role="presentation"
      className={cn(skeletonVariants({ level, size }), className)}
      {...props}
    />
  );
}

Skeleton.displayName = 'Skeleton';
export { Skeleton };
